import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface MarkPhoneVerifiedResponse extends BackendResponse {}

export interface MarkPhoneVerifiedParameters extends NextApiParams {
  phone: string;
  code: string;
}

export const markPhoneVerified = withNextApi<
  MarkPhoneVerifiedResponse,
  MarkPhoneVerifiedParameters
>("/auth/MarkPhoneVerified");
